export default "__VITE_ASSET__CQWb$nrZ__"